export default __webpack_public_path__ + "static/media/urban-myth.2a9e8d82.png";